import { render, staticRenderFns } from "./MetodoAutenticacao.vue?vue&type=template&id=53f64555&scoped=true&"
import script from "./MetodoAutenticacao.vue?vue&type=script&lang=js&"
export * from "./MetodoAutenticacao.vue?vue&type=script&lang=js&"
import style0 from "./MetodoAutenticacao.vue?vue&type=style&index=0&id=53f64555&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f64555",
  null
  
)

export default component.exports